export default __webpack_public_path__ + "static/media/servicebench.bbc2970c.png";